import type { ReactNode } from 'react';

import { Checkbox } from '@connected/ui/components/checkbox';
import { Label } from '@connected/ui/components/label';
import { cn } from '@connected/ui/lib/utils';

export type CheckboxFieldProps = {
    name?: string;
    value: boolean;
    label: ReactNode;
    onChange: (value: boolean) => void;
};

export function CheckboxField({
    name,
    value,
    label,
    className,
    onChange,
    disabled = false,
    ...props
}: CheckboxFieldProps & Omit<React.HTMLProps<HTMLLabelElement>, keyof CheckboxFieldProps | 'ref'>) {
    return (
        <Label
            className={cn(
                'flex h-fit min-h-10 cursor-pointer items-center gap-2 pl-2',
                className,
                disabled && 'cursor-not-allowed opacity-50',
            )}
            {...props}
        >
            <Checkbox
                name={name}
                checked={value}
                onCheckedChange={value => onChange(value === true)}
                disabled={disabled}
            />
            <span className="text-text-primary text-sm font-normal">{label}</span>
        </Label>
    );
}
